import * as Types from '../../graphql/types'

import { gql } from 'apollo-boost'
import * as ApolloReactCommon from '@apollo/react-common'
import * as ApolloReactHooks from '@apollo/react-hooks'
const defaultOptions = {}
export type SendLawyerPortalProblemReportMutationVariables = Types.Exact<{
  input: Types.SendLawyerPortalProblemReportInput
}>

export type SendLawyerPortalProblemReportMutation = {
  __typename?: 'Mutation'
  sendLawyerPortalProblemReport: boolean
}

export const SendLawyerPortalProblemReportDocument = gql`
  mutation SendLawyerPortalProblemReport($input: SendLawyerPortalProblemReportInput!) {
    sendLawyerPortalProblemReport(input: $input)
  }
`
export type SendLawyerPortalProblemReportMutationFn = ApolloReactCommon.MutationFunction<
  SendLawyerPortalProblemReportMutation,
  SendLawyerPortalProblemReportMutationVariables
>
export function useSendLawyerPortalProblemReportMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    SendLawyerPortalProblemReportMutation,
    SendLawyerPortalProblemReportMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    SendLawyerPortalProblemReportMutation,
    SendLawyerPortalProblemReportMutationVariables
  >(SendLawyerPortalProblemReportDocument, options)
}
export type SendLawyerPortalProblemReportMutationHookResult = ReturnType<
  typeof useSendLawyerPortalProblemReportMutation
>
export type SendLawyerPortalProblemReportMutationResult =
  ApolloReactCommon.MutationResult<SendLawyerPortalProblemReportMutation>
export type SendLawyerPortalProblemReportMutationOptions = ApolloReactCommon.BaseMutationOptions<
  SendLawyerPortalProblemReportMutation,
  SendLawyerPortalProblemReportMutationVariables
>
